import { useWeb3React } from '@web3-react/core';
import {
    CHAIN_INFO,
    ChainInfo,
    EnabledChains,
    SupportedChains,
} from '../../config/constants';
import useErrorState from '../../context/error/useErrorState';
import { switchNetwork } from '../../web3/utils';
import Select from '../../components/Select';
import { config } from '../../config/config';
import { ChainIcons } from '../../assets/icons';

type ChainInfoExtended = ChainInfo[EnabledChains[number]] & {
    chainId: EnabledChains[number];
};

const ChainSelector = () => {
    const { library, chainId } = useWeb3React();
    const { setError } = useErrorState();

    const currentChain = chainId
        ? CHAIN_INFO[chainId as EnabledChains[number]]?.label
        : undefined;

    const switchChain = async (option: ChainInfoExtended) => {
        try {
            await switchNetwork({
                library,
                chainId: option.chainId,
            });
        } catch (error) {
            setError(error);
        }
    };

    return (
        <Select
            initialValue={currentChain}
            onChange={switchChain}
            options={config.enabledChains.map(
                (chainId) =>
                    ({
                        ...CHAIN_INFO[chainId],
                        chainId,
                    } as ChainInfoExtended)
            )}
            optionKey='label'
            renderOption={(option) => (
                <>
                    {ChainIcons[option.chainId] ?? ChainIcons[SupportedChains.DEV]}
                    <span>{option.label ?? 'Chain'}</span>
                </>
            )}
            renderSelected={(selectedOption) => (
                <>
                    {ChainIcons[selectedOption.chainId] ??
                        ChainIcons[SupportedChains.DEV]}
                    <span>{selectedOption.label ?? 'Chain'}</span>
                </>
            )}
        />
    );
};

export default ChainSelector;
